// 데모 계정(username: demo)의 비행 회차 기록. BE mission-log 를 타지 않고 브라우저에만 둔다.
//
// 농장별로 나눠 담는다. 예전에는 배열 하나에 통째로 쌓아서, 농장을 바꾸면 이전 농장의
// 회차가 그대로 조회 탭과 지도에 남았다 — 칸 id 도 다른 농장 것이라 지도에서 칠할 칸을
// 못 찾는다. demoSections / demoCellSelection 과 같은 규칙이다.
//
// 회차는 데모 계정이 직접 날린 것만 남는다. 예전에는 로그인할 때마다 가짜 회차를
// 4건 심었는데, 그 기록이 저장소에 남아 있을 수 있어 읽고 쓸 때 걸러 낸다(seeded).

// v2 는 농장 구분이 없어 그대로 읽으면 농장이 섞인다. 키를 올려 통째로 버린다.
const STORAGE_KEY = "demo-mission-logs-v3";

const readAll = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    // 사생활 보호 모드 등에서 읽기가 막혀도 시연은 계속돼야 한다.
    return {};
  }
};

const writeAll = (map) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // 용량 초과 등은 시연을 막지 않는다. 새로고침하면 사라질 뿐이다.
  }
};

const keyOf = (farmId) => String(farmId ?? "");

export const loadDemoMissionLogs = (farmId) => {
  if (farmId == null) return [];
  const list = readAll()[keyOf(farmId)];
  if (!Array.isArray(list)) return [];
  // 예전 버전이 심은 회차를 저장해 뒀을 수 있다. 지금 설정과 칸 수·등급이 달라
  // 화면이 설명과 어긋나므로 버린다.
  return list.filter((log) => !log?.seeded);
};

export const saveDemoMissionLogs = (farmId, logs) => {
  if (farmId == null) return logs;
  const map = readAll();
  map[keyOf(farmId)] = (Array.isArray(logs) ? logs : []).filter((log) => !log?.seeded);
  writeAll(map);
  return logs;
};

export const sortDemoMissionLogs = (logs) =>
  [...logs].sort((a, b) => new Date(a.completedAt) - new Date(b.completedAt));
